module.exports = __webpack_public_path__ + "img/fernando-viviani.cd510f62.jpg";